import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Formik, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { FormContext } from "../../../contexts";

const getInitialValues = (recaptcha, initialValues) => ({
  ...(recaptcha ? { "g-captcha-response": "" } : {}),
  ...initialValues,
});
const Form = (props) => {
  const {
    form: CustomForm,
    formId,
    initialValues,
    validationSchema,
    onSubmit,
    validateOnBlur,
    onResetForm,
    formProps,
    recaptcha,
  } = props;

  const refreshFormCaptchaHandle = ({ condition, gRefresh }) => {
    if (condition) {
      gRefresh();
    }
  };

  const submitCallback = useCallback(
    (values, callback) =>
      callback.constructor.name === "AsyncFunction"
        ? callback(values)
        : new Promise((resolve, reject) => {
            try {
              const result = callback(values);
              resolve(result);
            } catch (error) {
              reject(error);
            }
          }),
    []
  );

  return (
    <Formik
      initialValues={getInitialValues(recaptcha, initialValues)}
      validationSchema={() =>
        Yup.object().shape({
          ...(recaptcha
            ? {
                "g-captcha-response": Yup.string().required(
                  "Resolva o captcha para prosseguir!"
                ),
              }
            : {}),
          ...(validationSchema ? validationSchema(Yup) : {}),
        })
      }
      onSubmit={(values, { setSubmitting }) => {
        if (onSubmit) {
          submitCallback(values, onSubmit).finally(() => {
            setSubmitting(false);
            refreshFormCaptchaHandle({
              condition: recaptcha,
              gRefresh: () => false,
              ...values,
            });
          });
        }
      }}
      validateOnBlur={validateOnBlur}
    >
      {(formikBag) => {
        const { values, handleSubmit } = formikBag;

        function handleReset(evt) {
          if (onResetForm) {
            onResetForm(...[{ ...values }, { ...props, ...formikBag }, evt]);
          }

          refreshFormCaptchaHandle({
            condition: recaptcha,
            gRefresh: () => false,
            ...values,
          });
        }

        return (
          <FormContext.Provider value={{ recaptcha }}>
            <FormikForm
              onSubmit={handleSubmit}
              id={formId}
              onReset={(e) => handleReset(e)}
            >
              {React.createElement(CustomForm, {
                ...formProps,
                formId,
                initialValues,
                recaptcha,
              })}
            </FormikForm>
          </FormContext.Provider>
        );
      }}
    </Formik>
  );
};

Form.defaultProps = {
  initialValues: {},
  onSubmit: null,
  onResetForm: null,
  validateOnBlur: false,
  validationSchema: null,
  formProps: null,
  recaptcha: false,
};

Form.propTypes = {
  form: PropTypes.elementType.isRequired,
  formId: PropTypes.string.isRequired,
  initialValues: PropTypes.objectOf(Object),
  onSubmit: PropTypes.func,
  onResetForm: PropTypes.func,
  validateOnBlur: PropTypes.bool,
  validationSchema: PropTypes.func,
  formProps: PropTypes.instanceOf(Object),
  recaptcha: PropTypes.bool,
};

Form.requiredProps = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.objectOf(Object).isRequired,
  submitForm: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(Object).isRequired,
  isValid: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  touched: PropTypes.objectOf(Object).isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default Form;
